var I = /* @__PURE__ */ ((E) => (E.HIDDEN = "HIDDEN", E.VISIBLE_WHEN_TYPED = "VISIBLE_WHEN_TYPED", E.ALWAYS_VISIBLE = "ALWAYS_VISIBLE", E))(I || {});
export {
  I as SuggestionVisibility
};
